module.exports = __webpack_public_path__ + "img/trophy.0b945c2d.png";